angular.module("vgresiduos").controller("webhookConfigCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `webhook-config`);
		};
	}
]);
